import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Observes the element passed to the returned callback ref with
 * `IntersectionObserver` and reports whether it intersects the root.
 */
export const useIntersectionObserver = ({ options, freezeOnceVisible = false, initialIsIntersecting = false, onChange, } = {}) => {
    const [isIntersecting, setIsIntersecting] = useState(initialIsIntersecting);
    const [ref, setRef] = useState(null);
    const frozen = useRef(false);
    const { threshold = 0, root = null, rootMargin = '0%' } = options || {};
    const updateEntry = useCallback(([entry]) => {
        if (!entry)
            return;
        const isElementIntersecting = entry.isIntersecting;
        setIsIntersecting((prev) => {
            if (prev === isElementIntersecting || (prev && freezeOnceVisible))
                return prev;
            if (onChange)
                onChange(isElementIntersecting);
            return isElementIntersecting;
        });
        if (freezeOnceVisible && isElementIntersecting)
            frozen.current = true;
    }, [freezeOnceVisible, onChange]);
    useEffect(() => {
        if (!ref || frozen.current)
            return;
        const observer = new IntersectionObserver(updateEntry, {
            threshold,
            root,
            rootMargin,
        });
        observer.observe(ref);
        return () => {
            observer.disconnect();
        };
    }, [threshold, root, rootMargin, updateEntry, ref]);
    return { ref: setRef, current: ref, isIntersecting };
};
//# sourceMappingURL=useIntersectionObserver.js.map